import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["termsModal", "scrollArea", "confirmButton", "agreeButton"]
  static values = { target: String }

  show() {
    this.termsModalTarget.hidden = false;
    // モーダル表示時にスクロール状態をリセット
    this.resetScrollState();
  }

  confirm() {
    this.termsModalTarget.hidden = true;
    // 同意ボタン有効化
    if (this.agreeButtonTarget) {
      this.agreeButtonTarget.disabled = false;
      this.agreeButtonTarget.classList.remove('bg-muted', 'text-muted-foreground', 'cursor-not-allowed');
      this.agreeButtonTarget.classList.add('bg-primary', 'text-primary-foreground', 'hover:bg-primary-hover');
    }
  }

  // スクロールイベントハンドラー
  handleScroll(event) {
    const target = event.currentTarget;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    // 最下部から10px以内に到達したかをチェック
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isAtBottom) {
      this.enableConfirmButton();
    }
  }

  // ボタン有効化
  enableConfirmButton() {
    if (this.hasConfirmButtonTarget) {
      this.confirmButtonTarget.disabled = false;
      this.confirmButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed');
      this.confirmButtonTarget.classList.add('hover:bg-primary-hover');
    }
  }

  // スクロール状態をリセット（モーダル表示時）
  resetScrollState() {
    if (this.hasConfirmButtonTarget) {
      this.confirmButtonTarget.disabled = true;
      this.confirmButtonTarget.classList.add('opacity-50', 'cursor-not-allowed');
      this.confirmButtonTarget.classList.remove('hover:bg-primary-hover');
    }
  }

  // 利用規約の目次用、クリックした項にヘッダーを考慮して高さで移動する
  scrollToSection(event) {
    const targetId = event.currentTarget.dataset.termsTargetValue
    const targetElement = document.querySelector(targetId)

    if (targetElement) {
      const targetPosition = targetElement.offsetTop - 60
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }
}

